import { proxyApi } from "@custouch/proxy-use"

/**
 *  获取系统物料详情
 * @param { "form" | "lottery" | "webinar" | "site" | "landingpage" | "attachment" | "video"} type 物料类型
 * @param {string} resourceId 物料id
 */
export const GetMaterialDetail = (type, resourceId) =>
    proxyApi({
        module: "reference",
        target: "resource",
        data: {
            type,
            resourceId
        },
        freeLogin: 1
    })
